import { diemXepLoaiKPI, tienDoKPI, trangThaiKPI } from '../../constants';

// Màu tag theo tiến độ công việc
export const tienDoColor = (tienDo: number) => {
    switch (tienDo) {
        case tienDoKPI.truoc: return '#22c55e'; // Trước
        case tienDoKPI.dung: return '#0ea5e9'; // Đúng
        case tienDoKPI.tre: return '#FF0000'; // Trễ
        case tienDoKPI.loi: return '#ef4444'; // Lỗi
        case tienDoKPI.dangThucHien: return '#FFC000'; // Đang TH
        default: return '#9ca3af';
    }
};
export const getXepLoaiByDiemDanhGia = (diemDanhGia: number, diemChuyenMon: number) => {
    if (diemDanhGia > 100) {
        if (diemChuyenMon < 70) {
            return "A";
        } else {
            return "A+";
        }
    } else if (diemDanhGia >= 96 && diemDanhGia <= 100) {
        return "A";
    } else if (diemDanhGia >= 85 && diemDanhGia <= 95) {
        return "B";
    } else if (diemDanhGia < 85) {
        return "C";
    }
    return "";
}

export const renderSpanCongViec = (record: any, trangThai: number) => {
    if (record.isTieuDe == 1) {
        return <label className="text-enter">{record.tenCongViec}</label>;
    }
    let result = { className: "text-enter", tilte: undefined };
    var isDoiMau = trangThai <= trangThaiKPI.thuHoi;
    if (record.idCha > 0 && record.idNVGiao > 0) {
        if (isDoiMau) {
            result.className = "text-enter kpi-giao-viec-cu";
        }
        result.tilte = "Công việc chưa hoàn thành thuộc KPI tháng trước do lãnh đạo giao";
    } else if (record.idCha > 0) {
        if (isDoiMau) {
            result.className = "text-enter kpi-thang-truoc";
        }
        result.tilte = "Công việc chưa hoàn thành thuộc KPI tháng trước";
    } else if (record.idNVGiao > 0) {
        if (isDoiMau) {
            result.className = "text-enter kpi-giao-viec";
        }
        result.tilte = "Công việc do lãnh đạo giao";
    }

    return <span className={result.className} title={result.tilte}>{record.tenCongViec} </span>;
}

export const getDiemXepLoaiByDiemDanhGia = (diemDanhGia: number, diemChuyenMon: number) => {
    if (diemDanhGia > 100) {
        if (diemChuyenMon < 70) {
            return diemXepLoaiKPI.a
        } else {
            return diemXepLoaiKPI.aPlus;
        }
    } else if (diemDanhGia >= 96 && diemDanhGia <= 100) {
        return diemXepLoaiKPI.a;
    } else if (diemDanhGia >= 85 && diemDanhGia <= 95) {
        return diemXepLoaiKPI.b;
    } else return diemXepLoaiKPI.c;
}

export const getDiemDanhGiaByDiemXepLoai = (diemXepLoai: number) => {
    if (diemXepLoai == diemXepLoaiKPI.aPlus) {
        return 105;
    } else if (diemXepLoai == diemXepLoaiKPI.a) {
        return 100;
    } else if (diemXepLoai == diemXepLoaiKPI.b) {
        return 95;
    } else return 84;
}

export const getXepLoai = (diemXepLoai: number) => {
    switch (diemXepLoai) {
        case diemXepLoaiKPI.aPlus:
            return "A+";
        case diemXepLoaiKPI.a:
            return "A";
        case diemXepLoaiKPI.b:
            return "B";
        case diemXepLoaiKPI.c:
            return "C";
        default:
            return "";
    }
}
